import moment from 'moment';
import { MeasureUnit, NewCartItem } from '../../../../services/MVP/models';
import { EMeasureUnit } from '../../../../store/commomTypes';

export function hasCommonPaymentType(items: NewCartItem[]): boolean {
  if (items.length === 0) return true;

  const firstPaymentType = items[0].extension_attributes.payment_type_gerdau;

  return items.every((item) => {
    if (item.extension_attributes.payment_type_gerdau !== firstPaymentType) {
      return false;
    }

    const destination = item.extension_attributes.destination_gerdau;
    const cartOpts = item.cartOptions[destination];

    if (!cartOpts?.paymentTerms?.length) return false;

    return cartOpts.paymentTerms.some((pt) => pt.term === firstPaymentType);
  });
}

export function isDateExpired(inputDate: string | Date) {
  const currentDate = moment();
  const date = moment(inputDate, 'DD/MM/YYYY');
  return date.isBefore(currentDate);
}

export function hasDuplicates(array: NewCartItem[]) {
  const hasDuplicate = array.reduce((acc: NewCartItem[], item: NewCartItem) => {
    const findAcc = acc.some(
      (accItem) =>
        accItem.sku === item.sku &&
        accItem.extension_attributes.measure_unity_gerdau ===
          item.extension_attributes.measure_unity_gerdau &&
        accItem.extension_attributes.expected_date_gerdau ===
          item.extension_attributes.expected_date_gerdau &&
        accItem.extension_attributes.destination_gerdau ===
          item.extension_attributes.destination_gerdau &&
        accItem.extension_attributes.payment_type_gerdau ===
          item.extension_attributes.payment_type_gerdau &&
        accItem.extension_attributes.tax_benefit_gerdau ===
          item.extension_attributes.tax_benefit_gerdau
    );

    if (findAcc) {
      return acc;
    }

    return [...acc, item];
  }, [] as NewCartItem[]).length;

  return hasDuplicate !== array.length;
}

type ConvertedQuantities = {
  [key in EMeasureUnit]?: number;
};

export const convertToUnits = ({
  quantity,
  measureUnits,
  type
}: {
  quantity: number;
  measureUnits: MeasureUnit[];
  type?: 'T' | 'KG';
}): ConvertedQuantities => {
  const convertedQuantities = measureUnits.reduce((acc, unit) => {
    const convMeasureKg = parseFloat(unit.convMeasureKg.replace(',', '.'));
    const convMeasureTo = parseFloat(unit.convMeasureTo.replace(',', '.'));

    const convertedQuantity =
      type === 'KG'
        ? quantity * Number(unit.multiple) * convMeasureKg
        : quantity * Number(unit.multiple) * convMeasureTo;

    return {
      ...acc,
      [unit.measure]: convertedQuantity.toFixed(3)
    };
  }, {});

  return convertedQuantities;
};
